import LanguageIcon from "@mui/icons-material/Language";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { useNavigate } from "react-router-dom";
import GfgModal from "@/components/GfgModal";
import { CONFIGS as MODAL_TEXT } from "@/constants/GfgModal";

/**
 * The international paywall on the Collections pages — the standalone twin of the campaign
 * builder's `international` modal (same GfgModal shell + copy), for use OUTSIDE the builder
 * provider. "Upgrade" opens the Account → Plan tab (the in-app upgrade surface); dismissing just
 * closes it (the country filter is a browse-only choice here, so there's no state to revert).
 */
export default function InternationalUpsellModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const navigate = useNavigate();
  const cfg = MODAL_TEXT.international;
  return (
    <GfgModal
      open={open}
      onClose={onClose}
      icon={<LanguageIcon sx={{ fontSize: 28, color: "var(--color-dark-dust)" }} />}
      title={cfg.title}
      description={cfg.description}
      primaryLabel={cfg.primaryLabel}
      secondaryLabel={cfg.secondaryLabel}
      primaryFirst
      primaryIcon={<LockOpenIcon />}
      onPrimary={() => navigate("/account", { state: { tab: "plan", nonce: Date.now() } })}
    />
  );
}
